// extracted by mini-css-extract-plugin
export default {"container":"HomePage_container__hW856","home-page":"HomePage_home-page__qS54T"};